import { ar } from 'date-fns/locale/ar'
import { az } from 'date-fns/locale/az'
import { bg } from 'date-fns/locale/bg'
import { cs } from 'date-fns/locale/cs'
import { de } from 'date-fns/locale/de'
import { enUS } from 'date-fns/locale/en-US'
import { es } from 'date-fns/locale/es'
import { faIR } from 'date-fns/locale/fa-IR'
import { fr } from 'date-fns/locale/fr'
import { hr } from 'date-fns/locale/hr'
import { hu } from 'date-fns/locale/hu'
import { is } from 'date-fns/locale/is'
import { it } from 'date-fns/locale/it'
import { ja } from 'date-fns/locale/ja'
import { ko } from 'date-fns/locale/ko'
import { nb } from 'date-fns/locale/nb'
import { nl } from 'date-fns/locale/nl'
import { pl } from 'date-fns/locale/pl'
import { pt } from 'date-fns/locale/pt'
import { ro } from 'date-fns/locale/ro'
import { ru } from 'date-fns/locale/ru'
import { sv } from 'date-fns/locale/sv'
import { th } from 'date-fns/locale/th'
import { tr } from 'date-fns/locale/tr'
import { vi } from 'date-fns/locale/vi'
import { zhCN } from 'date-fns/locale/zh-CN'
import { zhTW } from 'date-fns/locale/zh-TW'

export const dateLocales = {
  ar,
  az,
  bg,
  cs,
  de,
  enUS,
  es,
  fa: faIR,
  fr,
  hr,
  hu,
  is,
  it,
  ja,
  ko,
  nb,
  nl,
  pl,
  pt,
  ro,
  ru,
  sv,
  th,
  tr,
  vi,
  zh: zhCN,
  'zh-tw': zhTW,
}
